import { createDecorator } from '../../instantiation/common/instantiation.js';
import { ID } from './diagnostics.js';
const IDiagnosticsService = ( createDecorator(ID));
export { IDiagnosticsService };
